'use client';

import Icon from '@/components/ui/AppIcon';

export default function NewsletterSection() {
  const handleRedirect = () => {
    window.open('https://stan.store/maryambellakbira', '_blank');
  };

  return (
    <section className="py-32 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="bg-foreground p-12 md:p-16 rounded-3xl text-center relative overflow-hidden">
          {/* Background Decoration */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-10 left-10 w-32 h-32 bg-accent rounded-full blur-3xl animate-float-slow"></div>
            <div className="absolute bottom-10 right-10 w-40 h-40 bg-white rounded-full blur-3xl animate-float-slow" style={{ animationDelay: '2s' }}></div>
          </div>

          <div className="relative z-10">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full mb-6">
              <Icon name="EnvelopeIcon" size={16} className="text-accent" />
              <span className="text-micro text-accent">Free Resources</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Join 1,500+ Insiders on the BOLD Inside Scoop
            </h2>
            <p className="text-lg text-white/70 mb-10 max-w-2xl mx-auto">
              A quarterly newsletter with events, free resources, personal reflections & exclusive opportunities
            </p>

            <button
              onClick={handleRedirect}
              className="px-8 py-4 bg-white text-foreground rounded-full font-bold text-sm uppercase tracking-wider hover:bg-white/90 transition-all hover:scale-105 shadow-lg inline-flex items-center gap-2"
            >
              <Icon name="EnvelopeIcon" size={20} />
              <span>Subscribe Now</span>
              <Icon name="ArrowRightIcon" size={16} />
            </button>

            <p className="text-xs text-white/50 mt-6">
              No spam, ever. Unsubscribe anytime.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}